import React from 'react';
import './trustRow.css'
import {Row , Col} from "react-bootstrap";


function TrustRow({icon, title, desc}) {
    return (
           <Col sm={12} md={6} lg={6} xl={12} className={'row-wrapper'}>
               {icon}

               <div className={'text-part'}>
                   <h4>{title}</h4>
                   <p>{desc}</p>
               </div>
           </Col>
    );
}

export default TrustRow;